var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rates.length
    ? _c(
        "div",
        {
          ref: "wrapperRef",
          staticClass: "lpu-reviews-list",
          attrs: { "data-qa": "lpu_reviews_list" },
        },
        [
          _c(_setup.CoreImageLightbox, { ref: "lightboxRef" }),
          _vm._v(" "),
          _c(_setup.PatientProfileModal, {
            attrs: {
              "is-visible": _setup.isProfileVisible,
              "patient-data": _setup.patientProfile,
            },
            on: { close: _setup.closePatientProfile },
          }),
          _vm._v(" "),
          _vm._l(_setup.visibleRates, function (rate) {
            return _c(_setup.ReviewCard, {
              key: rate.id,
              attrs: { rate: rate, lpu: _vm.lpu },
              on: {
                "open-image": _setup.onOpenImage,
                "open-author": _setup.openPatientProfile,
              },
            })
          }),
          _vm._v(" "),
          _setup.hiddenRates.length
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExpanded,
                      expression: "isExpanded",
                    },
                  ],
                },
                _vm._l(_setup.hiddenRates, function (rate) {
                  return _c(_setup.ReviewCard, {
                    key: rate.id,
                    attrs: { rate: rate, lpu: _vm.lpu },
                    on: {
                      "open-image": _setup.onOpenImage,
                      "open-author": _setup.openPatientProfile,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }